import { VideoStatus } from '@monorepo/types';

export interface StatusColors {
  bgColor: string;
  borderColor: string;
}

/**
 * Get background and border colors for a video based on its status
 */
export const getStatusColors = (status: VideoStatus): StatusColors => {
  switch (status) {
    case VideoStatus.Published:
      return {
        bgColor: 'rgba(135, 208, 104, 0.12)',
        borderColor: '#87d068',
      };
    case VideoStatus.Ready:
      return {
        bgColor: 'rgba(102, 126, 234, 0.12)',
        borderColor: '#667eea',
      };
    case VideoStatus.CreationFailed:
      return {
        bgColor: 'rgba(255, 77, 79, 0.12)',
        borderColor: '#ff4d4f',
      };
    default:
      return {
        bgColor: 'rgba(255, 193, 7, 0.12)',
        borderColor: '#ffc107',
      };
  }
};
